export default "<p>\n  stx works!\n</p>\n";